// Pure proto -> TS shapes and their mappings, shared by the services that
// carry them. Two rules keep this module loadable by the node test runner:
// no grpc-web import, and no relative import (node resolves this graph itself
// and will not guess file extensions).
export function protoAuthorToTs(protoAuthor) {
    if (!protoAuthor)
        return null;
    return {
        userId: protoAuthor.getUserId() || '',
        email: protoAuthor.getEmail() || '',
        firstName: protoAuthor.getFirstName() || '',
        lastName: protoAuthor.getLastName() || '',
        commentColor: protoAuthor.getCommentColor() || '',
        avatarUrl: protoAuthor.getAvatarUrl() || ''
    };
}
export function protoFolderToTs(protoFolder) {
    const parentFolderId = typeof protoFolder.hasParentFolderId === 'function' && protoFolder.hasParentFolderId()
        ? protoFolder.getParentFolderId() || undefined
        : undefined;
    const owner = typeof protoFolder.hasOwner === 'function' && protoFolder.hasOwner()
        ? protoAuthorToTs(protoFolder.getOwner()) || undefined
        : undefined;
    return {
        id: protoFolder.getId() || '',
        projectId: protoFolder.getProjectId() || '',
        ownerUserId: protoFolder.getOwnerUserId() || '',
        name: protoFolder.getName() || '',
        color: protoFolder.getColor() || '#3B82F6',
        sortOrder: protoFolder.getSortOrder() || 0,
        createdAt: protoFolder.getCreatedAt() || 0,
        updatedAt: protoFolder.getUpdatedAt() || 0,
        parentFolderId,
        owner
    };
}
export function protoArtifactToTs(protoArtifact) {
    // hasShowLabel/getShowLabel: proto3 `optional bool`. We want to distinguish
    // "explicitly false" (label hidden) from "not set" (renderer defaults true).
    const showLabel = typeof protoArtifact.hasShowLabel === 'function' && protoArtifact.hasShowLabel()
        ? protoArtifact.getShowLabel()
        : undefined;
    const author = typeof protoArtifact.hasAuthor === 'function' && protoArtifact.hasAuthor()
        ? protoAuthorToTs(protoArtifact.getAuthor()) || undefined
        : undefined;
    return {
        id: protoArtifact.getId() || '',
        folderId: protoArtifact.getFolderId() || '',
        artifactType: protoArtifact.getArtifactType() || 'placemark',
        name: protoArtifact.getName() || '',
        color: protoArtifact.getColor() || '#3B82F6',
        displayUnit: protoArtifact.getDisplayUnit() || undefined,
        geometryJson: protoArtifact.getGeometryJson() || '',
        sortOrder: protoArtifact.getSortOrder() || 0,
        createdAt: protoArtifact.getCreatedAt() || 0,
        updatedAt: protoArtifact.getUpdatedAt() || 0,
        icon: protoArtifact.getIcon() || undefined,
        showLabel,
        author
    };
}
